import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { ResourceModel } from "@app/models/rest/resource";
import { ResourceRestService } from "@app/services/hal/resource-rest.service";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class ResourceStore extends RealTimeDataStore<ResourceModel> {
  constructor() {
    const resourceRestService = inject(ResourceRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(resourceRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Resource", true);
  }
}
